export default "__VITE_ASSET__edcb5d02__"